import React, { useEffect, useState } from 'react';
import UniDropAdv from './UniDrop/UniDropAdv';
import { Col, Row } from 'antd';

const DropdownTree = ({
    form,
    extraData,
    data,
    elements
}) => {
    const [source_params, setSourceParams] = useState({});
    const [elementLists, setElementList] = useState([])
    const [nextIndex, setNextIndex] = useState(0);


    useEffect(() => {
        setElementList(elements);
    }, []);

    useEffect(() => {
        if (!nextIndex) return;
        if (nextIndex === elementLists.length) return;
        let __elements = [...elementLists];
        let nextDropdown = __elements[nextIndex];
        nextDropdown.hide = true;
        nextDropdown.sourceParams = { ...nextDropdown.sourceParams, ...source_params };
        setElementList(__elements)
    }, [source_params]);

    const showNextDropdown = (index, value) => {
        let __elements = [...elementLists];
        let urlParams = { ...source_params };
        elementLists.forEach((x, i) => {
            if (i > index) {
                x.hide = false;
                form.setFieldsValue({ [x.data_index]: null });
                form.setFieldsValue({ [x.p_data_index]: null });
                if (urlParams[x.data_index]) {
                    delete urlParams[x.data_index]
                }
            };
            if (i === index) {
                urlParams[x.data_index] = value;
            };
            if ((i + 1) === index) {
                x.hide = true;
            }
        });
        setElementList(__elements);
        setSourceParams(urlParams);
        setNextIndex(index + 1);
    }


    // const showNextDropdown = (index) => {
    //     let nextDropdownIndex = index + 1;
    //     if (nextDropdownIndex === elementLists.length) return;
    //     let elements = [...elements];
    //     elements[nextDropdownIndex].visible = true;
    //     for (var i = 0; i <= index; i++) {
    //         let currentDataIndex = elements[i]['data_index'];
    //         elements[nextDropdownIndex].sourceParams = {
    //             ...elements[nextDropdownIndex].sourceParams,
    //             [currentDataIndex]: form.getFieldsValue()[currentDataIndex]
    //         }
    //     }
    //     // elements[nextDropdownIndex].sourceParams = {
    //     //     ...elements[nextDropdownIndex].sourceParams,
    //     //     [currentDataIndex]: form.getFieldsValue()[currentDataIndex]
    //     // };
    //     console.log(elements[nextDropdownIndex]);
    //     setMultiDropdown({
    //         ...multiDropdownData,
    //         elements
    //     })
    // }

    return (
        <Row>
            {
                elementLists.map((x, i) => (
                    x.hide ?
                        <Col span={x.colSize || 12}>
                            <UniDropAdv
                                // onChange={(e) => {
                                //     setSourceParams({
                                //         ...source_params,
                                //         [x.data_index]: e
                                //     })
                                //     setNextIndex(i + 1);
                                // }}
                                onChange={(e) => showNextDropdown(i, e)}
                                labelCol={x.labelColSpan ? x.labelColSpan : 8}
                                bg="transparent"
                                form={form}
                                colSpan={x.colSize || 24}
                                multiSelect={x.multiSelect}
                                url={
                                    x.url
                                        ? x.url
                                        : x.source === "mdict"
                                            ? "/mdict"
                                            : x.source === "usergroup"
                                                ? "/usergroup"
                                                : x.source === "cropdown"
                                                    ? "/cropdown"
                                                    : x.source === "dynamic"
                                                        ? "/dynamicDropdown"
                                                        : ""
                                }
                                disabled={x.disabled}
                                source={x.source}
                                options={x.data}
                                extraData={extraData}
                                urlData={x.sourceParams ? x.sourceParams : {}}
                                pname={x.p_data_index ? x.p_data_index : `p${x.name}`}
                                name={x.data_index}
                                label={x.label}
                                errorMessage={"Please Select " + x.label}
                                required={x.required}
                                placeholder={x.placeHolder}
                                defaultValue={x.defaultValue ? x.defaultValue : null}
                                includeAll={x.includeAll ? x.includeAll : false}
                                searchable={x.searchable ? x.searchable : false}
                            />
                        </Col>
                        : <></>
                ))
            }
        </Row>
    )
};

export default DropdownTree;